<div class="flex flex-row w-full">
    <ng-container *ngFor="let c of commands; index as i">
        <button
            *ngIf="c.label && !(c.isHidden && c.isHidden(el)) && (!c.layout || c.layout === 'normal')"
            color="{{c.type}}" mat-button [disabled]="c?.isDisabled(el)"
            class="w-full h-auto min-h-[52px] overflow-hidden action-b"
            (click)="onClick(i)">
            <span class="block line-clamp-2 whitespace-normal"
                *ngIf="showLabelWhenLoading(c, el)">{{(c.label
                | translate) | async}}</span>
            <mat-icon *ngIf="c.icon && !isCommandLoading(c, el)"
                class="ml-4">{{c.icon}}</mat-icon>
            <mat-spinner *ngIf="isCommandLoading(c, el)" diameter="20"
                class="inline-block ml-4">
            </mat-spinner>
        </button>

        <button
            *ngIf="c.label && !(c.isHidden && c.isHidden(el)) && c.layout === 'flat'"
            color="{{c.type}}"
            mat-flat-button [disabled]="c?.isDisabled(el)"
            class="w-full h-auto min-h-[52px] overflow-hidden action-b"
            (click)="onClick(i)">
            <span class="block line-clamp-2 whitespace-normal"
                *ngIf="showLabelWhenLoading(c, el)">{{(c.label
                | translate) | async}}</span>
            <mat-icon *ngIf="c.icon && !isCommandLoading(c, el)"
                class="ml-4">{{c.icon}}</mat-icon>
            <mat-spinner *ngIf="isCommandLoading(c, el)" diameter="20"
                class="inline-block ml-4">
            </mat-spinner>
        </button>

        <button
            *ngIf="c.label && !(c.isHidden && c.isHidden(el)) && c.layout === 'raised'"
            color="{{c.type}}"
            mat-raised-button [disabled]="c?.isDisabled(el)"
            class="w-full h-auto min-h-[52px] overflow-hidden action-b"
            (click)="onClick(i)">
            <span class="block line-clamp-2 whitespace-normal"
                *ngIf="showLabelWhenLoading(c, el)">{{(c.label
                | translate) | async}}</span>
            <mat-icon *ngIf="c.icon && !isCommandLoading(c, el)"
                class="ml-4">{{c.icon}}</mat-icon>
            <mat-spinner *ngIf="isCommandLoading(c, el)" diameter="20"
                class="inline-block ml-4">
            </mat-spinner>
        </button>

        <button mat-icon-button
            *ngIf="c.icon && !c?.isDisabled(el) && !c?.label"
            (click)="onClick(i)" [color]="c.type">
            <mat-icon>{{c.icon}}</mat-icon>
        </button>
    </ng-container>
</div>
